<template>
  <div style="overflow: auto;height:100%">
    <el-table tooltip-effect="dark" style="width:100%" :data="tableData_" v-loading="loading_">
      <template slot="empty">
        <div id="notDate">
          <img src="../../../assets/imgs/project/project_statistics.png" alt />
          <p>译员完成任务之后才可统计哦</p>
        </div>
      </template>
      <!-- :span-method="arraySpanMethod" 合并行-->
      <el-table-column align="center" type="index" label="序号" min-width="80"></el-table-column>
      <el-table-column align="center" label="项目名称" prop="projectName"></el-table-column>
      <el-table-column align="center" label="任务名称" prop="taskName"></el-table-column>
      <el-table-column v-if="!standard" align="center" label="任务类型" prop="taskType"></el-table-column>
      <el-table-column align="center" label="完成时间" prop="finishTime" min-width="140"></el-table-column>
      <!-- <el-table-column label="任务类型" prop="taskType" width="92"></el-table-column> -->
      <el-table-column align="center" label="中文字数" prop="chineseWordNum" min-width="100"></el-table-column>
      <!-- <el-table-column label="译文字数" prop="wordNum" width="100"></el-table-column> -->
      <el-table-column align="center" label="译员" prop="userName" min-width="100"></el-table-column>
      <el-table-column align="center" label="单价/元" prop="salary" min-width="124">
        <template slot-scope="scope">
          <input type="number" v-model="scope.row.salary" max="10000" min="10" step="10"
            @change="salaryChange(scope.row)" />元/千字
          <!-- {{scope.row.salary/100}}元/千字 -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="总价/元" prop min-width="124">
        <template slot-scope="scope">{{getSalary(scope.row)}}</template>
      </el-table-column>
      <!-- <el-table-column label="总价/元" prop="totalMoney" width="124"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
       type:[Array]
    },
    loading:{
        type:Boolean
    }
  },
  data() {
    return {
    //   tableData_: this.tableData,
      standard:true,
    };
  },
  computed: {
      tableData_(){
          return this.tableData
      },
      loading_(){
          return this.loading
      }
  },
  created() {
      if (process.env.VUE_APP_NAME !== "hospital") {
      this.standard = false // true
    } else {
      this.standard = false
    }
  },
  methods: {
      getSalary (row) {
      return ((row.chineseWordNum * row.salary) / 1000).toFixed(2);
    },
      // 修改单价
    salaryChange (row) {
      if (row.salary < 10) {
        row.salary = 10
      } else if (row.salary > 10000) {
        row.salary = 10000
      }
      var params = {
        id: row.id,
        salary: row.salary * 100
      };
      this.catReq1Service("/api/v1/fileTask/task_update", params)
        .then(function (response) {

        });
    },
  },



};
</script>
<style lang="less" scoped>
</style>
